import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getCourseIdFromUrl } from '@/helpers/route';
import { useHandleRedirectToAccounts } from '@/hooks/useHandleRedirectToAccounts';
import { useStorageListener } from '@/hooks/useStorageListener';
import { AccountsQueryString, LoginQueryString } from '@/interfaces/queryString';
import { setUser } from '@/redux/auth/slice';
import { loginAccounts } from '@/services/accounts';
import socket from '@/services/socket';
import { enTokenKey, getUserInfo } from '@/services/token';

const Auth: FC<PropsWithChildren<any>> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const { hasFirstAccess } = useHandleRedirectToAccounts();
  const dispatch = useDispatch();
  const token = useStorageListener(enTokenKey.token);
  const user = getUserInfo();

  useEffect(() => {
    const hasCourseId = getCourseIdFromUrl() !== null;
    const params = new URLSearchParams(window.location.search);
    const accountsToken = params.get(AccountsQueryString.token);
    const hasForceLogin = params.get(LoginQueryString.forceLogin);

    if (hasCourseId && !accountsToken && !hasForceLogin) {
      setIsAuthenticated(isAuthenticated => (isAuthenticated ? isAuthenticated : true));
    } else {
      loginAccounts(setIsAuthenticated);
    }
  }, []);

  useEffect(() => {
    if (token) {
      socket.emit('user-identified', user);

      setIsAuthenticated(isAuthenticated => (isAuthenticated ? isAuthenticated : true));
      dispatch(setUser(getUserInfo()));
    }
  }, [token, dispatch, user]);

  useEffect(() => {
    dispatch(setUser(getUserInfo()));
  }, [dispatch]);

  if (isAuthenticated && !hasFirstAccess) {
    return children;
  }

  return (
    <div className='root-nutror-loading'>
      <img src='https://eduzz-houston.s3.amazonaws.com/topbar/logos/nutror-colored.svg' alt='logotipo do nutror' />
      <div className='root-nutror-loading-box'>
        <div className='root-nutror-progress-bar' />
      </div>
    </div>
  );
};

export default Auth;
